export const sortDepartments = (data) => {
    const result = [];

    if (data.length) {
        data.forEach((elem) => {
            const department = result.find((vacancy) => vacancy?.department?.id === elem?.department?.id);

            if (department?.vacancies) {
                department.vacancies.push(elem);
            } else {
                const newDepartment = {
                    department: {
                        id: elem?.department?.id,
                        name: elem?.department?.name,
                    },
                    vacancies: [elem],
                };

                result.push(newDepartment);
            }
        });

        result.sort((a, b) => a.department.name.localeCompare(b.department.name));
    }

    return result;
};
